import {
  EnrichmentAttributeTypeEnum,
  useTargetAttributesQuery,
} from '~/generated/graphql';

type UseTargetAttributesArgs = {
  targetType: EnrichmentAttributeTypeEnum | EnrichmentAttributeTypeEnum[];
};
export function useTargetAttributes({ targetType }: UseTargetAttributesArgs) {
  const targetTypes = Array.isArray(targetType) ? targetType : [targetType];
  const { data, loading, error, refetch } = useTargetAttributesQuery({
    variables: {
      targetTypes,
    },
  });

  return { data, loading, error, refetch };
}
